import "./style.scss";
import { Typography } from "components";
import { pocketMoniUrl } from "routes/routePaths";
import pmLogo from "assets/images/pocketmoni-logo.png";
import registerSuccess from "assets/images/register-success.jpeg";

const GuestRequestNINSuccess = () => {
  return (
    <div className="mx-auto text-center guest-success-container">
      <a href={pocketMoniUrl} target="_blank" rel="noopener noreferrer">
        <img src={pmLogo} width="150" alt="PocketMoni" />
      </a>{" "}
      <div style={{ marginTop: "4rem" }}>
        <img src={registerSuccess} alt="" width="160" />
        <Typography variant="subtitle1" state="primary" className={"mt-2"}>
          Congratulations!
        </Typography>
        <Typography state="primary" className={"mt-4"}>
          Your NIN and PocketMoni phone number have been linked successfully
        </Typography>
      </div>
    </div>
  );
};

export default GuestRequestNINSuccess;
